import {
  gql,
} from "@apollo/client";

export const GET_USER_FROM_ADMIN = gql`
  query {
    findAllUser {
      id
      fullname
      username
      email
      password
      role
    }
  }
`;

export const FIND_USER = gql`
  query {
    findUser {
      id
      fullname
      role
    }
  }
`;

export const GET_PROJECT_SUPERVISOR = gql`
  query FindAllProjectSupervisor {
    findAllProjectSupervisor {
      id
      created_by {
        id
        fullname
        username
        role
      }
      title
      assignee {
        id
        fullname
        username
        role
      }
      description
      status
      attachment
      is_read
      start_date
      due_date
      worker {
        id
        fullname
      }
      notes {
        id
        project_id
        note
      }
    }
  }
`;

export const GET_PROJECT_PLANNER = gql`
  query FindAllProjectPlanner {
    findAllProjectPlanner {
      id
      created_by {
        id
        fullname
      }
      assignee {
        id
        fullname
      }
      title
      description
      status
      attachment
      is_read
      start_date
      due_date
      worker {
        id
        fullname
      }
      notes {
        id
        project_id
        note
      }
    }
  }
`;

export const GET_TASK_PLANNER = gql`
  query FindAllTaskPlanner {
    findAllTaskPlanner {
      id
      project_id
      task
      is_check
    }
  }
`;

export const GET_WORKER_LIST = gql`
  query FindAllUserWorker {
    findAllUserWorker {
      id
      fullname
    }
  }
`;

export const GET_TASK_WORKER = gql`
  query FindAllTaskWorker {
    findAllTaskWorker {
      id
      project_id
      assignee
      title
      description
      start_date
      due_date
      attachment
      status
      is_read
      note {
        id
        task_id
        note
      }
    }
  }
`;

export const GET_TASK_SUPERVISOR = gql`
  query FindAllTaskSupervisor {
    findAllTaskSupervisor {
      id
      project_id
      task
      is_check
    }
  }
`;

export const GET_ALL_PROJECT = gql`
  query {
    findAllTask {
      id
      title
      description
      start_date
      due_date
    }
  }
`;


